import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export function TitlePreview({ cfg }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    if (!cfg.name?.trim()) { setP(null); return; }
    const t = setTimeout(() => {
      api.get("/admin/title-preview", { params: { vendor: cfg.vendor || "", name: cfg.name || "", short_name: cfg.short_name || "",
        exam_code: cfg.exam_code || "", udemy_exams: +cfg.udemy_exams || 0, udemy_questions: +cfg.udemy_questions || 0,
        video_episode_size: +cfg.video_episode_size || 15 } }).then((r) => setP(r.data)).catch(() => setP(null));
    }, 350);
    return () => clearTimeout(t);
  }, [cfg.name, cfg.vendor, cfg.short_name, cfg.exam_code, cfg.udemy_exams, cfg.udemy_questions, cfg.video_episode_size]);
  if (!p) return null;
  const rows = [
    ["intro", "Udemy intro lecture (lecture 1)", p.intro.title, p.intro.chars, null, true],
    ["udemy", "Udemy course title", p.udemy.title, p.udemy.chars, p.udemy.limit, p.udemy.ok],
    ["episode", "YouTube episode title (pattern)", p.episode.title, p.episode.chars, p.episode.limit, p.episode.ok],
  ];
  return (
    <div className="rounded-md border border-zinc-200 bg-zinc-50 px-4 py-3 space-y-2" data-testid="title-preview">
      <p className="text-xs font-semibold uppercase tracking-wide text-zinc-500">Titles the machine will write <span className="font-normal normal-case">— short name in use: “{p.short_used}”</span></p>
      {rows.map(([k, label, title, chars, limit, ok]) => (
        <div key={k} data-testid={`title-preview-${k}`} className="flex items-start gap-2">
          {ok ? <CheckCircle2 size={14} className="text-emerald-600 mt-0.5 shrink-0" /> : <AlertTriangle size={14} className="text-red-600 mt-0.5 shrink-0" />}
          <div className="min-w-0">
            <p className="text-[11px] text-zinc-500">{label}{limit ? <span className={ok ? "" : "text-red-700 font-semibold"}> · {chars}/{limit} characters</span> : <span> · {chars} characters</span>}</p>
            <p className={`text-sm font-medium break-words ${ok ? "text-zinc-900" : "text-red-700"}`}>{title}</p>
          </div>
        </div>
      ))}
      {p.warnings.length > 0 && (
        <ul className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2 space-y-1" data-testid="title-preview-warnings">
          {p.warnings.map((w, i) => <li key={i}>{w}</li>)}
        </ul>
      )}
    </div>
  );
}
